import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import WorksheetView from "ToddleLibrary/routes/WorksheetView";
export default store => {
  return {
    path: "worksheets",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "toddle-library" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [WorksheetView(store)],
  };
};
